/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class CommunicationVerificationService {
  private httpClient = inject(HttpClient)

  public sendEmailVerification(country: string, language: string, emailId: string): Observable<TransactionIdDto> {
    return this.httpClient.post<TransactionIdDto>(`${environment.publicApi.baseUrl}/emails/${emailId}/otp?country=${country}`, null, {
      headers: { 'accept-language': language },
    })
  }

  public sendSmsVerification(country: string, language: string, mobileId: string) {
    return this.httpClient.post<TransactionIdDto>(`${environment.publicApi.baseUrl}/mobiles/${mobileId}/otp?country=${country}`, null, {
      headers: { 'accept-language': language },
    })
  }

  verifyMobileWithSmsPin(country: any, locale: any, mobileId: string, mobileSmsVerification: { smsPin: string }) {
    return this.httpClient.patch<TransactionIdDto>(
      `${environment.publicApi.baseUrl}/mobiles/${mobileId}/verification?smsPin=${mobileSmsVerification.smsPin}&country=${country}`,
      {},
      { headers: { 'accept-language': locale } },
    )
  }

  verifyEmailWithOtpPin(country: string, locale: string, emailId: string, emailOtpVerification: { otpPin: string }) {
    return this.httpClient.patch<TransactionIdDto>(
      `${environment.publicApi.baseUrl}/emails/${emailId}/verification?otp=${emailOtpVerification.otpPin}&country=${country}`,
      {},
      { headers: { 'accept-language': locale } },
    )
  }
}

export interface TransactionIdDto {
  transactionId?: string
  valid?: boolean
}
